import { takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypesNO05';
import * as sagas from './NO05.saga';

export function* watchNO05() {
  // NO05_STATS_REQUEST is dispatched from inside searchNO05OrdersSaga (fullInitialStatsLoad)
  // itself now, purely to flip statsLoading on for the cards spinner — it's not meant to
  // trigger its own fetch here too, so there's no watcher for it.
  yield takeLatest(actionTypes.NO05_SEARCH_REQUEST,       sagas.searchNO05OrdersSaga);
  yield takeLatest(actionTypes.NO05_LOAD_MORE_REQUEST,    sagas.loadMoreNO05OrdersSaga);
  yield takeLatest(actionTypes.NO05_ORDER_DETAIL_REQUEST, sagas.fetchNO05OrderDetailSaga);
}
